import {
  DEACTIVE,
  DEACTIVE_SUCCESS,
  DELETE,
  DELETE_SUCCESS,
  GET_CATEGORIES,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORY_FILE_SUB_TYPE_SUCCESS,
  GET_CATEGORY_LIST,
  GET_CATEGORY_LIST_SUCCESS,
  GET_DETAIL,
  GET_DETAIL_SUCCESS,
  GET_REFERENCE_DATA_DETAIL_SUCCESS,
  REQUEST_ERROR,
  SET_LOADING,
  SET_UPDATING_CATEGORY,
  SUBMIT_DATA,
  SUBMIT_DATA_SUCCESS,
} from '../types/category';
import { updateStates } from '@/utils/reducer';

const initState = {
  list: {
    data: [],
    metadata: {},
  },
  isLoading: false,
  isUpdating: false,
  error: '',
  item: {},
  items: [],
  categoryTypes: [],
  channels: [],
  fileSubTypes: [],
};

const reducer = (state = initState, action) => {
  const { type } = action;
  switch (type) {
    case GET_CATEGORIES:
    case GET_DETAIL:
      return updateStates(state, {
        isLoading: true,
      });
    case SUBMIT_DATA:
    case DEACTIVE:
    case DELETE:
      return updateStates(state, {
        isUpdating: true,
      });

    case SET_UPDATING_CATEGORY:
      return updateStates(state, { isUpdating: action.payload || false });

    case GET_CATEGORIES_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        list: action.data,
      });

    case GET_DETAIL_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        item: action.data,
      });

    case GET_REFERENCE_DATA_DETAIL_SUCCESS:
      return updateStates(state, {
        ...action.result,
      });

    case SET_LOADING:
      return updateStates(state, {
        isLoading: action.isLoading,
      });

    case REQUEST_ERROR:
      return updateStates(state, {
        isLoading: false,
      });

    case SUBMIT_DATA_SUCCESS:
      return updateStates(state, {
        isUpdating: false,
        item: action.data || state.item,
      });

    case GET_CATEGORY_FILE_SUB_TYPE_SUCCESS:
      return updateStates(state, { fileSubTypes: action.payload });

    case GET_CATEGORY_LIST_SUCCESS:
      return updateStates(state, { items: action.payload });

    case DELETE_SUCCESS:
      return updateStates(state, {
        isUpdating: false,
        item: null,
      });
    case DEACTIVE_SUCCESS:
      return updateStates(state, {
        isUpdating: false,
        item: action.payload,
      });
    default:
      return state;
  }
};

export default reducer;
